import { Component } from '@angular/core';
import { ReturnConditionsComponent } from '../return-conditions/return-conditions.component';

@Component({
  selector: 'app-returns',
  imports: [
    ReturnConditionsComponent
  ],
  templateUrl: './returns.component.html',
  styleUrl: './returns.component.scss',
  standalone: true
})
export class ReturnsComponent {

}
